import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	slaTitle: {
		id: 'servicedesk-sla-settings.header.sla-title',
		defaultMessage: 'Service level agreements',
		description: 'title for SLA App',
	},
	slaDescriptionJsm: {
		id: 'servicedesk-sla-settings.header.sla-description-jsm',
		defaultMessage:
			'Set time goals with Service Level Agreements (SLAs) to help drive better quality of service across your service project team.',
		description: 'descritpion for SLA App',
	},
	slaListTitle: {
		id: 'servicedesk-sla-settings.header.sla-list-title',
		defaultMessage: 'SLAs in this project:',
		description: 'title for slat list ',
	},
	addNewSla: {
		id: 'servicedesk-sla-settings.header.add-new-sla',
		defaultMessage: 'Add SLA',
		description: 'label for adding new sla button',
	},
	calendarSelection: {
		id: 'servicedesk-sla-settings.header.calendar-selection',
		defaultMessage: 'Calendar selection',
		description: 'This option is used to select the calendar',
	},
});
